export default {
  label: 'Height',
};
